import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6971aae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://gitlab.com/javier-sedano/oidc-vue/-/tree/master#idp" }, "Documentation", -1))
const _hoisted_2 = { for: "idp" }
const _hoisted_3 = { for: "clientId" }
const _hoisted_4 = { for: "clientSecret" }
const _hoisted_5 = { for: "scope" }
const _hoisted_6 = { for: "baseUrl" }
const _hoisted_7 = { for: "backend" }
const _hoisted_8 = { for: "extraQueryParamsJson" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "extraQueryParam" }, [
  /*#__PURE__*/_createTextVNode(" Extra query params (json):  "),
  /*#__PURE__*/_createElementVNode("span", { class: "extraQueryParamTooltip" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Example: {\"ui_locales\": \"es-ES\"}"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest" }, "spec")
    ])
  ])
], -1))

import { ref } from 'vue';
import { ConfigurationService } from '@/services/ConfigurationService';


export default /*#__PURE__*/_defineComponent({
  __name: 'OidcConfiguration',
  setup(__props) {

const idp = ref(ConfigurationService.idp);
const clientId = ref(ConfigurationService.clientId);
const clientSecret = ref(ConfigurationService.clientSecret);
const scope = ref(ConfigurationService.scope);
const baseUrl = ref(ConfigurationService.baseUrl);
const backend = ref(ConfigurationService.backend);
const extraQueryParamsJson = ref(ConfigurationService.extraQueryParamsJson);

function reset() {
  ConfigurationService.reset();
  window.location.reload();
}

function save() {
  console.log(idp.value);
  ConfigurationService.idp = idp.value;
  ConfigurationService.clientId = clientId.value;
  ConfigurationService.clientSecret = clientSecret.value;
  ConfigurationService.scope = scope.value;
  ConfigurationService.baseUrl = baseUrl.value;
  ConfigurationService.backend = backend.value;
  ConfigurationService.extraQueryParamsJson = extraQueryParamsJson.value;
  window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, [
      _createTextVNode(" Configuration "),
      _createElementVNode("input", {
        type: "button",
        value: "Reset",
        onClick: reset
      }),
      _createElementVNode("input", {
        type: "button",
        value: "Save",
        onClick: save
      }),
      _createTextVNode("  "),
      _hoisted_1
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("label", _hoisted_2, [
        _createTextVNode("IdP: "),
        _withDirectives(_createElementVNode("input", {
          id: "idp",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((idp).value = $event)),
          size: "50"
        }, null, 512), [
          [_vModelText, idp.value]
        ])
      ])
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("label", _hoisted_3, [
        _createTextVNode("Client Id: "),
        _withDirectives(_createElementVNode("input", {
          id: "clientId",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clientId).value = $event)),
          size: "50"
        }, null, 512), [
          [_vModelText, clientId.value]
        ])
      ])
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("label", _hoisted_4, [
        _createTextVNode("Client Secret: "),
        _withDirectives(_createElementVNode("input", {
          id: "clientSecret",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((clientSecret).value = $event)),
          size: "50"
        }, null, 512), [
          [_vModelText, clientSecret.value]
        ])
      ])
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("label", _hoisted_5, [
        _createTextVNode("Scope: "),
        _withDirectives(_createElementVNode("input", {
          id: "scope",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((scope).value = $event)),
          size: "50"
        }, null, 512), [
          [_vModelText, scope.value]
        ])
      ])
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("label", _hoisted_6, [
        _createTextVNode("App base URL: "),
        _withDirectives(_createElementVNode("input", {
          id: "baseUrl",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((baseUrl).value = $event)),
          size: "50"
        }, null, 512), [
          [_vModelText, baseUrl.value]
        ])
      ])
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("label", _hoisted_7, [
        _createTextVNode("Backend endpoint: "),
        _withDirectives(_createElementVNode("input", {
          id: "backend",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((backend).value = $event)),
          size: "50"
        }, null, 512), [
          [_vModelText, backend.value]
        ])
      ])
    ]),
    _createElementVNode("p", null, [
      _createElementVNode("label", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          id: "extraQueryParamsJson",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((extraQueryParamsJson).value = $event)),
          size: "50"
        }, null, 512), [
          [_vModelText, extraQueryParamsJson.value]
        ])
      ])
    ])
  ]))
}
}

})